module.exports = __webpack_public_path__ + "static/media/xpress-favorite-game.ff3bd799.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/xpress-favorite-game.svg
// module id = 814
// module chunks = 7